module.exports = __webpack_public_path__ + "img/dot.798e76ee.png";